module.exports = __webpack_public_path__ + "static/img/yaevinn.839c1d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/yaevinn.png
// module id = oieH
// module chunks = 0